module.exports = __webpack_public_path__ + "static/media/2.9b9d5b3b.jpg";